import {
  HttpUtilService,
  Logger,
  HttpClient,
  HttpResponse,
  AgentSessionManager,
  ApiUriConstants,
} from '@nice-ccf/core-sdk';

/**
 * Class to handle agent leg
 */
export class AgentLegService {
  logger: Logger = new Logger('ACD', 'AgentLegService');
  protected utilService: HttpUtilService = new HttpUtilService();
  private agentSession: AgentSessionManager = <AgentSessionManager>{};

  /**
   * @example
   * ```
   * const agentLegSvc = new AgentLegService();
   * ```
   */
  constructor() {
    this.agentSession = AgentSessionManager.instance;
  }

  /**
   * Method to connect agent leg
   * @example
   * ```
   * dialAgentLeg();
   * ```
   */
  public dialAgentLeg(): Promise<HttpResponse> {
    const sessionId = this.agentSession.getSessionId();
    const baseUrl = this.agentSession.auth.getCXoneConfig().acdApiBaseUri;
    const authToken = this.agentSession.auth.getAuthToken().accessToken;
    const reqInit = this.utilService.initHeader(authToken);
    const url = baseUrl + ApiUriConstants.DIAL_AGENT_LEG_URI.replace('{sessionId}', sessionId);
    return new Promise<HttpResponse>((resolve, reject) => {
      HttpClient.post(url, reqInit).then(
        (response: HttpResponse) => {
          this.logger.info('dialAgentLeg', 'dial agent leg success');
          resolve(response);
        },
        (error: HttpResponse) => {
          this.logger.error('dialAgentLeg', 'dial agent leg failed :-' + error.toString());
          reject(error);
        }
      );
    });
  }

  /**
   * Method to disconnect agent leg
   * @example
   * ```
   * endAgentLeg();
   * ```
   */
  public endAgentLeg(): Promise<HttpResponse> {
    const sessionId = this.agentSession.getSessionId();
    const baseUrl = this.agentSession.auth.getCXoneConfig().acdApiBaseUri;
    const authToken = this.agentSession.auth.getAuthToken().accessToken;
    const reqInit = this.utilService.initHeader(authToken);
    const url = baseUrl + ApiUriConstants.END_AGENT_LEG_URI.replace('{sessionId}', sessionId);
    return new Promise<HttpResponse>((resolve, reject) => {
      HttpClient.post(url, reqInit).then(
        (response: HttpResponse) => {
          this.logger.info('endAgentLeg', 'end agent leg success');
          resolve(response);
        },
        (error: HttpResponse) => {
          this.logger.error('endAgentLeg', 'end agent leg failed :-' + error.toString());
          reject(error);
        }
      );
    });
  }
}
